export const TOGGLE_STEP_STATUS_CLIENTE = "TOGGLE_STEP_STATUS_CLIENTE";
export const TOGGLE_STEP_STATUS_TECNICO = "TOGGLE_STEP_STATUS_TECNICO";
export const GET_STATUS_STEPS_TECNICO = "GET_STATUS_STEPS_TECNICO";
export const TOGGLE_STATUS_FLUXO = "TOGGLE_STATUS_FLUXO";
